import React from 'react';

type ChevronProps = {
  color?: 'orange' | 'grey',
  onClick?: any
}

const Chevron: React.FC<ChevronProps> = ({color = 'orange', onClick}) => {

    const strokeColor = color === 'orange' ? '#e35100' : '#939393';

    return(
        <div onClick={onClick} style={{display: 'flex', alignItems: 'center'}}>
            <svg xmlns="http://www.w3.org/2000/svg" width="14.243" height="8.485" viewBox="0 0 14.243 8.485">
            <g id="Group_396" data-name="Group 396" transform="translate(172.622 -326.086) rotate(90)">
                <g id="Rectangle_731" data-name="Rectangle 731" transform="translate(333.157 166.864) rotate(-135)" stroke={strokeColor} strokeWidth="1">
                <rect width="10" height="2" rx="1" stroke="none"/>
                <rect x="0.5" y="0.5" width="9" height="1" rx="0.5" fill="none"/>
                </g>
                <g id="Rectangle_730" data-name="Rectangle 730" transform="translate(334.571 165.551) rotate(135)" stroke={strokeColor} strokeWidth="1">
                <rect width="10" height="2" rx="1" stroke="none"/>
                <rect x="0.5" y="0.5" width="9" height="1" rx="0.5" fill="none"/>
                </g>
            </g>
            </svg>
    </div>
    )
}
export default Chevron;